module.exports = __webpack_public_path__ + "media/images/new-ui-images/download-icon-f9c1a149ab0f0203c02f965669316684.svg";